// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .foot-section{
    display: flex;
    flex-direction: column;
}
.footer{
    width: 100%;
    display: flex;
    gap: 30px;
    padding: 25px 0px;
    justify-content: space-between;
}
.copyright{
    font-size: 0.8rem;
    border-top: 1px solid #9999;
    display: flex;
    color: #ffff;
    justify-content: space-around;
    padding: 40px 0;
    letter-spacing: 2px;
}
.copyright .text span{
    color: #F09300;
}
.footer .about, .address, .time{
    font-size: 0.8rem;
    color: #999999;
}
.footer .title{
    font-size: 1rem;
    color: #ffffff;
    padding-bottom: 15px;
}
.contact{
    line-height: 24px;
}
.contact .phNumber{
    color: #F09300;
    font-size: 1.2rem;
    font-weight: 600;
}
.contact a{
    color: #ffffff;
    font-size: 0.7rem;
}
.contact .email{
    color: #ffffff;
    font-size: 1.1rem;
}
.explore .sections, .service .policies, .categ .book-cat{
    display: flex;
    flex-direction: column;
}
.explore a, .service a, .categ a{
    color: #999999;
    font-size: 0.8rem;
}

.copyright{
    font-size: 0.8rem;
    border-top: 1px solid #9999;
    background: #282828;
    display: flex;
    color: #ffff;
    justify-content: space-around;
    padding: 40px 0;
    letter-spacing: 2px;
}
.copyright .text span{
    color: #F09300;
} */

.foot-section {
    display: flex;
    flex-direction: column;
}

.footer {
    width: 100%;
    display: flex;
    gap: 30px;
    padding: 25px 0px;
    justify-content: space-between;
    flex-wrap: wrap; /* Ensures items wrap on smaller screens */
}

.footer > div {
    flex: 1 1 200px; /* Items will shrink and wrap when space is limited */
    min-width: 200px;
}

.about img {
    max-width: 100%; /* Ensures logo is responsive */
    height: auto;
}

.copyright {
    font-size: 0.8rem;
    border-top: 1px solid #999999;
    display: flex;
    flex-direction: column; /* Stack items vertically on smaller screens */
    align-items: center;
    color: #ffffff;
    padding: 20px 0;
    letter-spacing: 2px;
}

.copyright .text {
    text-align: center;
    margin-bottom: 10px;
}

.copyright .socialmedia {
    display: flex;
    gap: 10px;
    justify-content: center;
}

/* Contact Section */
.contact {
    line-height: 24px;
}

.contact .phNumber {
    color: #F09300;
    font-size: 1.2rem;
    font-weight: 600;
}

.contact a {
    color: #ffffff;
    font-size: 0.8rem;
}

.contact .email {
    color: #ffffff;
    font-size: 1rem;
}

/* Links and Sections */
.explore .sections,
.service .policies,
.categ .book-cat {
    display: flex;
    flex-direction: column;
}

.explore a,
.service a,
.categ a {
    color: #999999;
    font-size: 0.8rem;
}

/* Title Styling */
.footer .title {
    font-size: 1rem;
    color: #ffffff;
    padding-bottom: 15px;
    padding-left: 0 !important;
}
.footer .about, .address, .time{
    font-size: 0.8rem;
    color: #999999;
}
/* Responsive Styles */
@media (max-width: 768px) {
    .footer {
        flex-direction: column; /* Stack all sections vertically */
        gap: 20px;
        align-items: center;
        text-align: center; /* Align content to center for better readability */
    }

    .footer > div {
        width: 100%;
        margin-bottom: 20px; /* Add spacing between sections */
    }

    .copyright {
        padding: 20px 10px;
    }
}

@media (max-width: 480px) {
    .footer .title {
        font-size: 0.9rem;
    }

    .contact .phNumber {
        font-size: 1rem;
    }

    .contact .email {
        font-size: 0.9rem;
    }

    .explore a,
    .service a,
    .categ a {
        font-size: 0.7rem;
    }

    .copyright {
        font-size: 0.7rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqEG;;AAEH;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe,EAAE,0CAA0C;AAC/D;;AAEA;IACI,eAAe,EAAE,qDAAqD;IACtE,gBAAgB;AACpB;;AAEA;IACI,eAAe,EAAE,+BAA+B;IAChD,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB,EAAE,8CAA8C;IACtE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,uBAAuB;AACvB;;;IAGI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;IAGI,cAAc;IACd,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA,sBAAsB;AACtB;IACI;QACI,sBAAsB,EAAE,kCAAkC;QAC1D,SAAS;QACT,mBAAmB;QACnB,kBAAkB,EAAE,mDAAmD;IAC3E;;IAEA;QACI,WAAW;QACX,mBAAmB,EAAE,iCAAiC;IAC1D;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;;QAGI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* .foot-section{\n    display: flex;\n    flex-direction: column;\n}\n.footer{\n    width: 100%;\n    display: flex;\n    gap: 30px;\n    padding: 25px 0px;\n    justify-content: space-between;\n}\n.copyright{\n    font-size: 0.8rem;\n    border-top: 1px solid #9999;\n    display: flex;\n    color: #ffff;\n    justify-content: space-around;\n    padding: 40px 0;\n    letter-spacing: 2px;\n}\n.copyright .text span{\n    color: #F09300;\n}\n.footer .about, .address, .time{\n    font-size: 0.8rem;\n    color: #999999;\n}\n.footer .title{\n    font-size: 1rem;\n    color: #ffffff;\n    padding-bottom: 15px;\n}\n.contact{\n    line-height: 24px;\n}\n.contact .phNumber{\n    color: #F09300;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n.contact a{\n    color: #ffffff;\n    font-size: 0.7rem;\n}\n.contact .email{\n    color: #ffffff;\n    font-size: 1.1rem;\n}\n.explore .sections, .service .policies, .categ .book-cat{\n    display: flex;\n    flex-direction: column;\n}\n.explore a, .service a, .categ a{\n    color: #999999;\n    font-size: 0.8rem;\n}\n\n.copyright{\n    font-size: 0.8rem;\n    border-top: 1px solid #9999;\n    background: #282828;\n    display: flex;\n    color: #ffff;\n    justify-content: space-around;\n    padding: 40px 0;\n    letter-spacing: 2px;\n}\n.copyright .text span{\n    color: #F09300;\n} */\n\n.foot-section {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer {\n    width: 100%;\n    display: flex;\n    gap: 30px;\n    padding: 25px 0px;\n    justify-content: space-between;\n    flex-wrap: wrap; /* Ensures items wrap on smaller screens */\n}\n\n.footer > div {\n    flex: 1 1 200px; /* Items will shrink and wrap when space is limited */\n    min-width: 200px;\n}\n\n.about img {\n    max-width: 100%; /* Ensures logo is responsive */\n    height: auto;\n}\n\n.copyright {\n    font-size: 0.8rem;\n    border-top: 1px solid #999999;\n    display: flex;\n    flex-direction: column; /* Stack items vertically on smaller screens */\n    align-items: center;\n    color: #ffffff;\n    padding: 20px 0;\n    letter-spacing: 2px;\n}\n\n.copyright .text {\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.copyright .socialmedia {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n}\n\n/* Contact Section */\n.contact {\n    line-height: 24px;\n}\n\n.contact .phNumber {\n    color: #F09300;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n\n.contact a {\n    color: #ffffff;\n    font-size: 0.8rem;\n}\n\n.contact .email {\n    color: #ffffff;\n    font-size: 1rem;\n}\n\n/* Links and Sections */\n.explore .sections,\n.service .policies,\n.categ .book-cat {\n    display: flex;\n    flex-direction: column;\n}\n\n.explore a,\n.service a,\n.categ a {\n    color: #999999;\n    font-size: 0.8rem;\n}\n\n/* Title Styling */\n.footer .title {\n    font-size: 1rem;\n    color: #ffffff;\n    padding-bottom: 15px;\n    padding-left: 0 !important;\n}\n.footer .about, .address, .time{\n    font-size: 0.8rem;\n    color: #999999;\n}\n/* Responsive Styles */\n@media (max-width: 768px) {\n    .footer {\n        flex-direction: column; /* Stack all sections vertically */\n        gap: 20px;\n        align-items: center;\n        text-align: center; /* Align content to center for better readability */\n    }\n\n    .footer > div {\n        width: 100%;\n        margin-bottom: 20px; /* Add spacing between sections */\n    }\n\n    .copyright {\n        padding: 20px 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .footer .title {\n        font-size: 0.9rem;\n    }\n\n    .contact .phNumber {\n        font-size: 1rem;\n    }\n\n    .contact .email {\n        font-size: 0.9rem;\n    }\n\n    .explore a,\n    .service a,\n    .categ a {\n        font-size: 0.7rem;\n    }\n\n    .copyright {\n        font-size: 0.7rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
